import React from 'react';
import PropTypes from 'prop-types';

function SearchIcon() {
  return (
    <svg
      className="Seller-search-icon"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M21 21L15.3765 15.3765M17.5 10.25C17.5 14.2541 14.2541 17.5 10.25 17.5C6.24594 17.5 3 14.2541 3 10.25C3 6.24594 6.24594 3 10.25 3C14.2541 3 17.5 6.24594 17.5 10.25Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SellerSearchInput({ value, onChange, onEnter }) {
  return (
    <div className="Seller-search-field" data-name="SellerSearchInput">
      <SearchIcon />
      <input
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.isComposing) return; // 한글 IME 입력 중 엔터 방지
          if (e.key === 'Enter' && onEnter) onEnter();
        }}
        placeholder="검색"
        aria-label="상품 검색"
        className="Seller-search-input"
      />
    </div>
  );
}

SellerSearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
};

export default SellerSearchInput;
